module.exports = __webpack_public_path__ + "img/pearl-dean.21acbc80.png";